import SortSetting from "./KrSortSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrSortSetting = install(SortSetting); // 生成带有 install 方法的组件

export default KrSortSetting;
